import React from "react"
import { latest as API_URL } from "../../../../config/api";
import { rateChart } from "../widgets/Charts";
import { number_format, is_better_arrow } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";

class SidebarReview extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            totals : {
                current_year : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0,
                },
                last_year    : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0,
                },
                _vs_ : {
                    availably_room_night : 0,
                    rate_occupancy : 0,
                    room_night_occupancy : 0,
                    room_night_oos_stock : 0,
                    room_night_stock : 0,
                    room_stock : 0
                }
            },
            data_rate_hotel : {
                names : [], 
                percent_total_hotels : [], 
                values : []
            },
            data_production : {
                names : [],
                values : []
            },
            data_trending_time : {
                months : [],
                property_names : [],
                values : []
            }
        }
    }
    handleClickMenu() {
        this.state.period_menu_show === "hide-panel" ? this.setState({ period_menu_show : "" }) : this.setState({ period_menu_show : "hide-panel" });
    }
    handleClickMenuItem(key, value){
        const current_period  =  { 
            key : key, value : value 
        }
        this.props.setPeriodSidebarReview(current_period)
    }

    getOptionTypeBar = (chart) => {

        if(chart === "data_rate"){
            return rateChart(this.state.totals.current_year.rate_occupancy);
        }
    }
    
    componentWillReceiveProps(props) {

        let request_set = Object.keys(props.response_request).length,
        $self = this;
        if (request_set > 0){
            let result = props.response_request["result"];
            this.setState({ 
                totals  : result["occupancy_widget"]["totals"],
                data_rate_hotel : result["property_widget"],
                data_production : result["production_widget"],
                data_trending_time : result["trending_time_widget"]
            })
        }
    }
    activeSidebar(){
        this.props.setStateSidebarReview()
        if(this.props.sidebar_review.status === ""){
            this.setState({
                period_menu_show : "hide-panel"
            })
        }
    }

    render(){
        return (
            <div className={"sidebar-review " + this.props.sidebar_review.status + " " + this.props.sidebar_review.show}>
                <div className="head-sidebar">
                    <span onClick={this.activeSidebar.bind(this)} className="arrow-press">
                        <span className="arrow"></span>
                    </span>
                    <div className="select-style type-two ">
                        <span className="input-filters select blue not-arrow">
                            <span title="Room night">REVIEW</span>
                        </span>
                    </div>
                </div>
                <div className="container-review">
                    <div className="sidebar-wdg">
                        <span className="title">OCCUPANCY RATE</span>
                        <span className="highlight-title">
                            <ReactEcharts
                                option={this.getOptionTypeBar("data_rate") }
                                notMerge={true}
                                lazyUpdate={true}
                                theme={"theme_name"}
                            />
                        </span>
                        <div className="footer">
                            <div className="block-1">
                                <span className="last-year">LAST YEAR</span>
                                <span className="highlight-last-year">{this.state.totals.last_year.rate_occupancy}%</span>
                            </div>
                            <div className="block-2">
                                <span className={"rate-type " + is_better_arrow(this.state.totals._vs_.rate_occupancy)}></span>
                                <span className="highlight-rate">
                                    { this.state.totals._vs_.rate_occupancy }%
                                </span>
                            </div>
                        </div> 
                    </div>
                    <div className="sidebar-wdg">
                        <span className="title">ALLOTMENT</span>
                        <span className="highlight-title">{number_format(this.state.totals.current_year.room_night_stock)}</span>
                        <div className="footer">
                            <div className="block-1">
                                <span className="last-year">LAST YEAR</span>
                                <span className="highlight-last-year">{number_format(this.state.totals.last_year.room_night_stock, 2)}</span>
                            </div>
                            <div className="block-2">
                                <span className={"rate-type " + is_better_arrow(this.state.totals._vs_.room_night_stock)}></span>
                                <span className="highlight-rate">
                                {this.state.totals._vs_.room_night_stock}%
                                </span>
                            </div>
                        </div> 
                    </div>
                    <div className="sidebar-wdg">
                        <span className="title">AVAILABILITY</span>
                        <span className="highlight-title">{number_format(this.state.totals.current_year.availably_room_night)}</span>
                        <div className="footer">
                            <div className="block-1">
                                <span className="last-year">LAST YEAR</span>
                                <span className="highlight-last-year">{number_format(this.state.totals.last_year.availably_room_night)}</span>
                            </div>
                            <div className="block-2">
                                <span className={"rate-type " + is_better_arrow(this.state.totals._vs_.availably_room_night)}></span>
                                <span className="highlight-rate">
                                {this.state.totals._vs_.availably_room_night}%
                                </span>
                            </div>
                        </div> 
                    </div>
                    <div className="sidebar-wdg">
                        <span className="title">R/N</span>
                        <span className="highlight-title">{number_format(this.state.totals.current_year.room_night_occupancy)}</span>
                        <div className="footer">
                            <div className="block-1">
                                <span className="last-year">LAST YEAR</span>
                                <span className="highlight-last-year">{number_format(this.state.totals.last_year.room_night_occupancy)}</span>
                            </div>
                            <div className="block-2">
                                <span className={"rate-type " + is_better_arrow(this.state.totals._vs_.room_night_occupancy)}></span>
                                <span className="highlight-rate">
                                {this.state.totals._vs_.room_night_occupancy}%
                                </span>
                            </div>
                        </div> 
                    </div>
                    <div className="sidebar-wdg">
                        <span className="title">R/N OOS</span>
                        <span className="highlight-title">{number_format(this.state.totals.current_year.room_night_oos_stock)}</span>
                        <div className="footer">
                            <div className="block-1">
                                <span className="last-year">LAST YEAR</span>
                                <span className="highlight-last-year">{number_format(this.state.totals.last_year.room_night_oos_stock)}</span>
                            </div>
                            <div className="block-2">
                                <span className={"rate-type " + is_better_arrow(this.state.totals._vs_.room_night_oos_stock)}></span>
                                <span className="highlight-rate">
                                    {this.state.totals._vs_.room_night_oos_stock}%
                                </span>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        )
    }
}

export default SidebarReview


// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/widgets/SidebarReview.js